import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import RefershImage from '../../assets/images/refersh.png'
import authAction from '../../redux/auth/actions'


const HardRefershComponent = () => {
  const dispatch = useDispatch();
  const { tokenData, loading: getUserByTokenLoading } = useSelector((state) => state.auth);
  const { getUserDataByToken } = authAction;

  useEffect(() => {
    dispatch(getUserDataByToken())
  }, []);

  useEffect(() => {
    if (tokenData && tokenData.length > 0) {
      const latestVersion = tokenData[0].VersionCode;
      if (latestVersion) {
        localStorage.removeItem("version_code");
        localStorage.setItem("version_code", latestVersion);
      }
    }
  }, [tokenData]);


  const handleHardRefresh = () => {
    sessionStorage.clear();
    localStorage.removeItem("version_code");
    window.location.href = window.location.href;
  };

  return (
    <>
      {
        !getUserByTokenLoading ? <div className="wrapper" style={{ background: "#fff", height: '100vh' }}>
          <div className="container-fluid p-0">
            <div className="row no-gutters">
              <div className="col-sm-12 text-center">
                <div>
                  <img
                    src={RefershImage}
                    className="img-fluid iq-error-img-refesh"
                    alt="Version mismatch"
                  />
                  <h2 className="mb-0">Oops! This web application  is not updated.</h2>
                  <h3 className="mb-0">Kindly click on button.</h3>
                  <button className="btn btn-primary mt-3" onClick={handleHardRefresh} >
                    Refresh
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div> : ''
      }
    </>
  )
}

export default HardRefershComponent
